var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('img',{staticClass:"logo",attrs:{"alt":"Pepper logo","src":require("@/assets/images/logo.png")},on:{"click":_vm.toHome}}),_c('h1',[_vm._v("Site Directory")]),_vm._l((_vm.brands),function(brand,brandName){return _c('div',{key:brandName},[_c('h3',[_vm._v(_vm._s(brand.name))]),_vm._l((brand.devices),function(device,deviceName){return _c('div',{key:deviceName},[_c('h4',[_vm._v("Content for the device: "+_vm._s(device.name))]),_c('div',[_c('p',[_vm._v("Installation Instructions")]),_vm._l((device.installationInstructions),function(step,stepOrder){return _c('div',{key:`instructions-${stepOrder}`},[_c('router-link',{attrs:{"to":{
            name: 'instructions',
            params: {
              brand: brandName,
              device: deviceName,
              step: stepOrder
            },
            query: {
              mode: _vm.$route.query.mode || 'light'
            },
          }}},[_vm._v("Step "+_vm._s(stepOrder)+": "+_vm._s(step.title))])],1)})],2)])}),_vm._l((brand.categories),function(category,categoryName){return _c('div',{key:categoryName},[_c('h4',[_vm._v("Content for the category: "+_vm._s(category.name))]),_c('div',[_c('p',[_vm._v("Category Instructions")]),_vm._l((category.installationInstructions),function(step,stepOrder){return _c('div',{key:`instructions-${stepOrder}`},[_c('router-link',{attrs:{"to":{
            name: 'categoryInstructions',
            params: {
              brand: brandName,
              category: categoryName,
              step: stepOrder
            },
            query: {
              mode: _vm.$route.query.mode || 'light'
            },
          }}},[_vm._v("Step "+_vm._s(stepOrder)+": "+_vm._s(step.title))])],1)})],2)])})],2)}),_c('h3',[_vm._v("Demos")]),_c('div',[_c('router-link',{attrs:{"to":{
        name:'sendHelpTutorial',
        query: {
          mode: _vm.$route.query.mode || 'light'
        },
      }}},[_vm._v("Send Help Tutorial")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }